


























import Vue from 'vue'
import store from '@/store'
import PortfolioMetadata from '@/components/PortfolioMetadata.vue'
import api from '../api'
import { ImageFile, Portfolio } from '../types'

export default Vue.extend({
  name: 'PortfolioList',

  components: {
    PortfolioMetadata,
  },

  data: () => ({
    isBusy: false,
    skip: 0,
    take: 2,
    scrollTimeout: 0,
    portfolios: [] as Array<Portfolio>,
  }),

  methods: {
    checkScrollPosition() {
      const last = document.querySelector('.portfolio:last-child')
      if (last && this.elementIsFullyVisible(last)) {
        this.fetch()
      }
    },
    debounce() {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(this.checkScrollPosition.bind(this), 100)
    },
    featuredPhoto(portfolio: Portfolio): ImageFile | undefined {
      return portfolio.images
        && (portfolio.images.find(i => i.featured === true) || portfolio.images[0])
    },
    async fetch() {
      if (this.isBusy) return

      this.isBusy = true
      const nextBatch = await api.getPortfolios(this.skip, this.take)
      if (!nextBatch || nextBatch.length === 0) {
        this.stopScrollListener()
        this.isBusy = false
        return
      }

      this.portfolios = this.portfolios.concat(nextBatch)
      this.skip += this.take
      this.isBusy = false
    },
    elementIsFullyVisible(el: Element): boolean {
      return el.getBoundingClientRect().bottom < window.innerHeight
    },
    getDisplayClass(): string {
      return this.$route.query.show_md ? 'portfolio with-metadata' : 'portfolio hero'
    },
    photos(portfolio: Portfolio): Array<ImageFile> {
      return portfolio && (portfolio.images || []).slice(1) // omit 'feature' image
    },
    select(portfolio: Portfolio): void {
      store.setSelectedPortfolio(portfolio)
      this.$router.push({
        name: 'PortfolioDetail',
        params: { id: String(portfolio.id) },
        // query: { skip: String(this.skip), take: String(this.take) },
      })
    },
    srcFor(portfolio?: Portfolio, image?: ImageFile): string {
      if (!portfolio || !image) return ''

      return `${store.state.apiBaseUrl}/img/portfolio/${portfolio.id}/${image.remoteFilename}`
    },
    stopScrollListener() {
      window.removeEventListener('scroll', this.debounce)
    },
    styleUrlFor(portfolio?: Portfolio, image?: ImageFile) {
      if (!portfolio || !image) return ''

      return `url(${this.srcFor(portfolio, image)})`
    },
  },

  async mounted() {
    await this.fetch()
    window.addEventListener('scroll', this.debounce)
  },

  beforeDestroy() {
    this.stopScrollListener()
  },
})
